// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2qS5j","footer":"ModalUpdate_footer__3K_uw"};